<template>
  <div>
    {{ $t('payment_result.please_wait') }}
  </div>
</template>

<script>
import PaymentResponse from '../models/PaymentResponse'
import { Routes } from '../utils/Routes'
import { OrderWizardActionTypes as actions } from '../store/action-types'
import { webshopService } from '../../shared/services/WebshopService'

export default {
  name: 'SimplePayPaymentResult',

  data () {
    return {
      signature: null
    }
  },

  async created () {
    const r = this.$route.query.r
    const s = this.$route.query.s

    if (!r || !s) return

    const decodedResponse = await webshopService.checkSimplePayResponse({ simplePayResponse: r, simplePaySignature: s })
    const paymentResponse = new PaymentResponse({
      code: decodedResponse.r,
      transactionId: decodedResponse.t,
      event: decodedResponse.e,
      merchant: decodedResponse.m,
      orderId: decodedResponse.o,
      startTime: decodedResponse.startTime,
      invoiceId: decodedResponse.invoiceId,
      invoiceKey: decodedResponse.invoiceKey
    })

    this.$store.dispatch(actions.POST_ORDER_CLEANUP)
    if (paymentResponse.isSuccessful()) {
      this.$router.push({ name: Routes.THANK_YOU_BANKCARD.name, query: { response: paymentResponse.encode() } })
    } else {
      this.$router.push({ name: Routes.PAYMENT_FAILED.name, query: { response: paymentResponse.encode() } })
    }
  }
}
</script>
